import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Overlay, Tooltip } from '../../legacy-bootstrap';
import { useDraggable } from './hooks';
import styles from './ScaleBar.module.css';

/*
 * This component is the handle that is rendered on each side
 * of the slider bar which you can drag to resize the bar.
 */
const SliderHandle = ({
  tooltip,
  parentIsDragging,
  location,
  onStartDrag,
  onHandleMove,
}) => {
  const { dragProps, isDragging } = useDraggable({
    onStartDrag,
    onDragMove: distance => onHandleMove(location, distance),
  });
  const target = useRef();
  return (
    <div
      ref={target}
      className={styles.sliderHandle}
      data-testid={`scale-bar-${location}-handle`}
      {...dragProps}
    >
      <Overlay
        target={target.current}
        show={parentIsDragging || isDragging}
        placement='top'
        shouldUpdatePosition
      >
        <Tooltip id={`scale-bar-handle-tooltip-${location}`}>{tooltip}</Tooltip>
      </Overlay>
    </div>
  );
};

SliderHandle.propTypes = {
  tooltip: PropTypes.string.isRequired,
  parentIsDragging: PropTypes.bool.isRequired,
  location: PropTypes.oneOf(['left', 'right']).isRequired,
  onStartDrag: PropTypes.func.isRequired,
  onHandleMove: PropTypes.func.isRequired,
};

export default SliderHandle;
